var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.numberA1A3)?_c('div',[_c('span',{staticClass:"pr-1"},[_vm._v(" "+_vm._s(_vm.numberA1A3.toLocaleString(_vm.$i18n.locale, { maximumFractionDigits: 10, }))+" ")]),_c('span',[_vm._v(_vm._s(_vm.unit))])]):_c('div',[_vm._v(" - ")])}
var staticRenderFns = []

export { render, staticRenderFns }